import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const googleIntegrationService = {
    revokeGoogleIntegration,
    authenticateGoogleIntegration,
    getLocations,
    editProfile,
    getLocationListing,
    updateLocationListing,
    getCategories,
};

function getLocations() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/google/locations`, requestOptions).then(handleResponse);
}

function revokeGoogleIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/google/revoke-access`, requestOptions).then(handleResponse);
}

function authenticateGoogleIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/google/authenticate`, requestOptions).then(handleResponse);
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google:connect`, requestOptions).then(
        handleResponse,
    );
}

function getLocationListing(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google/listing`, requestOptions).then(
        handleResponse,
    );
}

function updateLocationListing(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google/listing`, requestOptions).then(
        handleResponse,
    );
}

function getCategories(query = '', limit = 50) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/categories?query=${query}&limit=${limit}`, requestOptions).then(
        handleResponse,
    );
}
